import { Calendar, Event } from 'react-big-calendar';

import { localizer } from '../../../utils/dayjs';

export interface IPropsDiscountCalendar {
  events?: Event[];
  height?: number | string;
  width?: number | string;
}

function DiscountCalendar(props: IPropsDiscountCalendar) {
  const { events = [], height, width } = props;

  return (
    <Calendar
      selectable={false}
      localizer={localizer}
      events={events}
      startAccessor="start"
      endAccessor="end"
      style={{ height: height || 450, width: width || '100%' }}
      views={['month', 'agenda']}
    />
  );
}

export default DiscountCalendar;
